/**
 * DetailFactsRestText text.
 */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * DetailFactsRestText text.
 */
const DetailFactsRestText = styled.span<{ margin?: boolean }>`
  color: ${Colors['text']};
  font-family: ${Fonts['light']};
  font-size: ${32 * Screen.widthRatio}px;
  line-height: ${40 * Screen.widthRatio}px;
  margin-left: ${(props) =>
    props.margin ? `${8 * Screen.widthRatio}px` : '0'};
`;

export default DetailFactsRestText;
